import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

export function DiscordCommunityLink({
  inviteUrl,
  label = "Open Discord",
  className,
}: {
  inviteUrl: string;
  label?: string;
  className?: string;
}) {
  return (
    <Button asChild className={className}>
      <a href={inviteUrl} rel="noopener noreferrer nofollow" target="_blank">
        {label}
        <ExternalLink className="size-4" aria-hidden="true" />
      </a>
    </Button>
  );
}
